// Global background system: drifting aurora blobs + fine grain overlay.
export function Aurora() {
  return (
    <div className="aurora" aria-hidden="true">
      <div className="aurora__blob aurora__blob--1" />
      <div className="aurora__blob aurora__blob--2" />
      <div className="aurora__blob aurora__blob--3" />
    </div>
  );
}

export function GrainOverlay() {
  return <div className="grain" aria-hidden="true" />;
}
